import { fmt as fmtK } from "../components/ui-kit";
import React, { useEffect, useState } from "react";
import api from "../lib/api";

export default function Reports() {
  const [rows, setRows] = useState([]);
  useEffect(() => { api.get("/reports/time").then((r) => setRows(r.data)).catch(() => {}); }, []);
  const total = rows.reduce((a, r) => a + (r.minutes || 0), 0);
  return (
    <div className="mx-auto max-w-5xl space-y-6">
      <div><h1 className="font-head text-3xl font-extrabold tracking-tight">Time-Spent Audit Report</h1>
        <p className="mt-1 text-muted-foreground">Session durations are recorded server-side for audit purposes only and never printed on clinical documents. Total: <b>{total.toFixed(1)} min</b></p></div>
      <TimeTable rows={rows} />
    </div>
  );
}

export function TimeTable({ rows }) {
  const fmt = (s) => fmtK(s);
  const csv = () => {
    const head = "tracking_id,client,clinician,document_type,started_at,ended_at,minutes,status\n";
    const body = rows.map((r) => [r.tracking_id, r.client_name, r.clinician, r.document_type, r.started_at, r.ended_at, r.minutes, r.status].map((v) => `"${v ?? ""}"`).join(",")).join("\n");
    const a = document.createElement("a"); a.href = URL.createObjectURL(new Blob([head + body], { type: "text/csv" })); a.download = "time_report.csv"; a.click();
  };
  return (
    <div className="overflow-x-auto rounded-2xl border border-border bg-card" data-testid="time-table">
      <div className="flex justify-end p-2"><button onClick={csv} className="text-xs font-semibold text-primary underline" data-testid="export-csv">Export CSV</button></div>
      <table className="w-full text-sm">
        <thead className="bg-muted/60 text-left text-xs uppercase tracking-wider text-muted-foreground"><tr>{["Client", "Clinician", "Document", "Started", "Ended", "Minutes", "Status"].map((h) => <th key={h} className="px-3 py-2">{h}</th>)}</tr></thead>
        <tbody>
          {rows.length === 0 && <tr><td colSpan={7} className="px-3 py-4 text-muted-foreground">No sessions yet.</td></tr>}
          {rows.map((r) => (
            <tr key={r.tracking_id} className="border-t border-border" data-testid={`time-row-${r.tracking_id}`}>
              <td className="px-3 py-2 font-semibold">{r.client_name || "(purged)"}</td><td className="px-3 py-2">{r.clinician}</td><td className="px-3 py-2">{r.document_type}</td>
              <td className="px-3 py-2">{fmt(r.started_at)}</td><td className="px-3 py-2">{fmt(r.ended_at)}</td><td className="px-3 py-2 font-mono">{r.minutes ?? "—"}</td><td className="px-3 py-2 capitalize">{r.status?.replace(/_/g, " ")}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
